import { Record } from 'immutable'

export interface IAssociatedContact {
  contactId: string
  isCompany: boolean
  name: string
}

const AssociatedContactRecord = Record({
  contactId: '',
  isCompany: false,
  name: '',
})

export class AssociatedContact extends AssociatedContactRecord
  implements IAssociatedContact {
  public static fromJS(initialState?: Partial<IAssociatedContact>) {
    return new AssociatedContact(initialState)
  }

  public readonly contactId: string
  public readonly isCompany: boolean
  public readonly name: string

  constructor(initialState?: Partial<AssociatedContact>) {
    initialState ? super(initialState) : super()
  }
}
